/**
 * @generated SignedSource<<641697ba13b9510a6a205573eb3d1da8>>
 * @relayHash 30f7986aba195278e1189f4b28aa525f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0537f6787d4dc30f8b976c06d412076756337d6f9f926f87fbb6ca7b2f561c72

import type { ConcreteRequest } from 'relay-runtime';
export type KnowledgeHubBrowseAllArticlesContainerQuery$variables = {
  cloudId: string;
  container: string;
  isAgentKbEnabled: boolean;
};
export type KnowledgeHubBrowseAllArticlesContainerQuery$data = {
  readonly knowledgeBase: {
    readonly knowledgeBase: {
      readonly __typename: "KnowledgeBaseSources";
      readonly edge: ReadonlyArray<{
        readonly node: {
          readonly sourceType: string;
          readonly sourceVisibility?: string | null;
        };
      } | null>;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
  readonly knowledgeBase_getLinkedSourceTypes: {
    readonly linkedSourceTypes?: ReadonlyArray<string | null> | null;
  } | null;
};
export type KnowledgeHubBrowseAllArticlesContainerQuery = {
  response: KnowledgeHubBrowseAllArticlesContainerQuery$data;
  variables: KnowledgeHubBrowseAllArticlesContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "container"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isAgentKbEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "container",
    "variableName": "container"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "sourceType"
},
v5 = {
  "condition": "isAgentKbEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "sourceVisibility"
    }
  ]
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "linkedSourceTypes"
    }
  ],
  "type": "KnowledgeBaseLinkedSourceTypes"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "KnowledgeHubBrowseAllArticlesContainerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "KnowledgeBaseQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeBase",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "knowledgeBase",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "KnowledgeBaseSourceEdge",
                      "kind": "LinkedField",
                      "name": "edge",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "KnowledgeBaseSource",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v4/*: any*/),
                              "action": "THROW"
                            },
                            (v5/*: any*/)
                          ]
                        }
                      ]
                    },
                    "action": "THROW"
                  }
                ],
                "type": "KnowledgeBaseSources"
              },
              (v6/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "knowledgeBase_getLinkedSourceTypes",
        "plural": false,
        "selections": [
          (v7/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KnowledgeHubBrowseAllArticlesContainerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "KnowledgeBaseQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeBase",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "knowledgeBase",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeBaseSourceEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "KnowledgeBaseSource",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "KnowledgeBaseSources"
              },
              (v6/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "knowledgeBase_getLinkedSourceTypes",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "0537f6787d4dc30f8b976c06d412076756337d6f9f926f87fbb6ca7b2f561c72",
    "metadata": {},
    "name": "KnowledgeHubBrowseAllArticlesContainerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a60e8987c6cc4804ac469aeb71bd070b";

export default node;
